module.exports = __webpack_public_path__ + "img/home-rightdesign.207305c5.svg";